import { useCallback, useContext, useEffect, useState } from 'react';

import { Button } from 'antd';

import { FormGroupContext } from '@/components/FormGroup';
import Categories from '@/components/wizard/Categories';
import Image from '@/components/wizard/Image';
import ProductDescription from '@/components/wizard/ProductDescription';
import ProductTitle from '@/components/wizard/ProductTitle';
import { validateFields } from '@/lib/validation';
import useAIProductExampleStore from '@/stores/AIProductExampleStore';
import useStepStore from '@/stores/steps';

import Wizard from '../..';
type DetailsProps = {
  onEdit?: () => void;
};

const Details = ({ onEdit }: DetailsProps) => {
  const { emit } = useContext(FormGroupContext);
  const nextStep = useStepStore(({ nextStep }) => nextStep);
  const [showEdit, setShowEdit] = useState(true);

  const aiProductExampleStore = useAIProductExampleStore(d => d);

  const submit = useCallback(async () => {
    const results = await emit({ type: 'validate' });

    if (!validateFields(results)) {
      onEdit?.();
      setShowEdit(false);
      return;
    }

    nextStep();
  }, [emit, nextStep, onEdit]);

  useEffect(() => {
    if (!aiProductExampleStore.hasData() && onEdit) {
      onEdit();
      setShowEdit(false);
    }
  }, [aiProductExampleStore, onEdit]);

  const handleEdit = useCallback(() => {
    if (onEdit) {
      onEdit();
      setShowEdit(false);
    }
  }, [onEdit]);

  return (
    <div className='mt-4 mb-28 flex flex-col gap-4'>
      <ProductTitle />
      <ProductDescription />
      <Categories />
      <Image />

      <Wizard.Footer inline closable preview reverseButtonsOnDesktop={false}>
        {showEdit && (
          <Button id='edit' type='default' onClick={handleEdit}>
            Quero Editar
          </Button>
        )}

        <Button type='primary' id='submit' onClick={submit}>
          Gostei, continuar
        </Button>
      </Wizard.Footer>
    </div>
  );
};
export default Details;
